import { List } from './List'
import { Employee } from './directories/Employee'

export class OppositionParent extends List {
  constructor(obj) {
    super(Opposition, obj)
  }
}

export class Opposition {
  constructor(obj) {
    this.id = obj?.id || null
    this.employee = new Employee(obj?.employee || null)
    this.period = obj?.period || null
    this.count = obj?.count || null
  }

  getForAPI() {
    return {
      id: this.id,
      employee: this.employee.getForAPI(),
      period: this.period,
      count: this.count
    }
  }
}
